exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-ltr-page-jsx": () => import("./../../../src/templates/ltr/page.jsx" /* webpackChunkName: "component---src-templates-ltr-page-jsx" */),
  "component---src-templates-rtl-page-jsx": () => import("./../../../src/templates/rtl/page.jsx" /* webpackChunkName: "component---src-templates-rtl-page-jsx" */),
  "component---src-templates-unvariant-jsx": () => import("./../../../src/templates/unvariant.jsx" /* webpackChunkName: "component---src-templates-unvariant-jsx" */)
}

